// removed by extract-text-webpack-plugin
module.exports = {"Footer":"Footer__Footer__Kzbfj","Row":"Footer__Row__3Y2GH","Links":"Footer__Links__3aQR8","Copyright":"Footer__Copyright__fLzrK","SubLi":"Footer__SubLi__2392-","Top":"Footer__Top__odqJK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.css
// module id = 178
// module chunks = 0